import script from "./partnerClubList.vue?vue&type=script&setup=true&lang=js"
export * from "./partnerClubList.vue?vue&type=script&setup=true&lang=js"

import "./partnerClubList.vue?vue&type=style&index=0&id=5d1e5d54&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d1e5d54"]])

export default __exports__